import type { Color, PieceSymbol } from 'chess.js';
import { Peca } from './Peca';

interface Props {
  /** Cor do jogador dono desta faixa (quem capturou). */
  cor: Color;
  /** Peças adversárias capturadas (mortas). */
  pecas: PieceSymbol[];
  /** Vantagem de material deste lado; só mostra se > 0. */
  vantagem?: number;
}

export function PecasCapturadas({ cor, pecas, vantagem = 0 }: Props) {
  const corMortas: Color = cor === 'w' ? 'b' : 'w';
  if (!pecas.length && vantagem <= 0) {
    return <div className="faixa-capturas faixa-capturas-vazia" aria-hidden="true" />;
  }
  return (
    <div
      className="faixa-capturas"
      aria-label={
        pecas.length
          ? `Peças capturadas: ${pecas.length}${vantagem > 0 ? `, vantagem +${vantagem}` : ''}`
          : vantagem > 0
            ? `Vantagem de material +${vantagem}`
            : 'Nenhuma peça capturada'
      }
    >
      <div className="fila-capturas">
        {pecas.map((tipo, i) => (
          <span className="captura-item" key={`${tipo}-${i}`}>
            <Peca tipo={tipo} cor={corMortas} />
          </span>
        ))}
      </div>
      {vantagem > 0 && <span className="vantagem-material">+{vantagem}</span>}
    </div>
  );
}
